<h2 mat-dialog-title class="tt-secondary-background" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary=".cdk-overlay-container" cdkDragHandle style="color: white">
    <span style="width: 100%; display: inline-flex; justify-content: space-between; align-items: center">
        <span>{{ get?.sublabel_helpcalc }}</span>
        <div style="display: flex; align-items: center">
            <button style="background: transparent; border: none; margin: none; outline: none; padding: none; color: white" (click)="cancel()"><span class="far fa-times"></span></button>
        </div>
    </span>
</h2>
<mat-dialog-content>
    <tt-grid-loading-overlay *ngIf="loading"></tt-grid-loading-overlay>
    <ng-container *ngIf="!loading && !!get">
        <tt-component-calculation [(get)]="get" [productUnits]="productUnits"></tt-component-calculation>
        <tt-input-number ttLabel="quantity_component" [(ttModel)]="get.quantity" ttTextAlign="right" ttFormatNumber ttDecimals="4"></tt-input-number>
        <tt-input *ngIf="get.stock_unit_no === ''" ttLabel="stock_unit" [ttModel]="get.stock_unit_no" ttReadonly></tt-input>
        <tt-select *ngIf="get.stock_unit_no > ''" ttLabel="stock_unit" [ttModel]="get.stock_unit_no" [ttData]="productUnits" ttDataId="unit_no" ttDataName="shortname" ttReadonly></tt-select>
    </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <tt-button-save (ttClick)="save()" [ttLoading]="saving" [ttDisabled]="loading || saving || !get"></tt-button-save>
</mat-dialog-actions>
